var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center loader-2-container"},[_c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":_vm.fullPage,"color":"var(--primary)","loader":_vm.loader},on:{"update:active":function($event){_vm.isLoading=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }